module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f44d.08c0a077.svg";